import { render, staticRenderFns } from "./DetalhesLegislacao.vue?vue&type=template&id=3da3457c"
import script from "./DetalhesLegislacao.vue?vue&type=script&lang=ts"
export * from "./DetalhesLegislacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports